import { createRoutine } from 'redux-saga-routines'
import { ISettingState } from './setting.interface'

const initialSettingsState: ISettingState = {
    settings: {
        id: 0,
        createdAt: new Date(),
        updatedAt: new Date(),
        deletedAt: new Date(),
        createdBy: 0,
        updatedBy: 0,
        deletedBy: 0,
        patientId: 0,
        minSystolic: 70,
        maxSystolic: 100,
        minDiastolic: 110,
        maxDiastolic: 150,
        allowReminders: false,
        reminderType: '',
        reminderTime: '00:00:00'
    },
    error: false,
    loading: false
}

export const getSettings = createRoutine('GET_SETTINGS')
export const addSettings = createRoutine('ADD_SETTINGS')
export const editSettings = createRoutine('EDIT_SETTINGS')

export default function patient(state = initialSettingsState, action: any) {
    switch (action.type) {

        case getSettings.TRIGGER: {
            return { ...state, loading: true, settings: {}, error: false, success: false }
        }
        case getSettings.SUCCESS: {
            return {
                ...state,
                loading: false,
                success: true,
                settings: action.payload,
                error: false
            }
        }
        case getSettings.FAILURE: {
            return {
                ...state,
                loading: false,
                success: false,
                error: true
            }
        }
        case addSettings.TRIGGER: {
            return { ...state, loading: true, error: false, success: false }
        }
        case addSettings.SUCCESS: {
            return {
                ...state,
                loading: false,
                success: true,
                error: false
            }
        }
        case addSettings.FAILURE: {
            return {
                ...state,
                loading: false,
                success: false,
                error: true
            }
        }
        case editSettings.TRIGGER: {
            return { ...state, loading: true, error: false, success: false }
        }
        case editSettings.SUCCESS: {
            return {
                ...state,
                loading: false,
                success: true,
                error: false
            }
        }
        case editSettings.FAILURE: {
            return {
                ...state,
                loading: false,
                success: false,
                error: true
            }
        }
        default:
            return state
    }
}
